angular.module('ihestiaWidgets.claims', ['ui.router']);